import React, { useEffect, useState } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { TbFilterEdit } from "react-icons/tb";
import { Button } from "@mui/material";
import { HttpService } from "../../service/HttpService";
import FullScreenLoader from "../../components/Loader/FullScreenLoader";
import DateTimeModal from "../Schedule/ScheduleListAdd/DateTimeModal";

const CloneHistory = () => {
  const dateFilterData = JSON.parse(
    localStorage.getItem("cloneHistoryDateFilter"),
  );
  const [clones, setClones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(15);
  const [rowCount, setRowCount] = useState(0);
  const [searchData, setSearchData] = useState([]);
  const [page, setPage] = useState(0);
  const [openDateModal, setOpenDateModal] = useState(false);
  const [startDate, setStartDate] = useState(
    dateFilterData?.startDate || dayjs().startOf("month").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    dateFilterData?.endDate || dayjs().endOf("month").format("YYYY-MM-DD"),
  );
  const [selectedRadio, setSelectedRadio] = useState(
    dateFilterData?.selectedRadio || "month",
  );

  const httpService = new HttpService();

  const fetchClones = async () => {
    setLoading(true);
    try {
      //   const res = await httpService.get(
      //     `motherplant/clones_history?page=${
      //       page + 1
      //     }&pageSize=${pageSize}&start_date=${startDate}&end_date=${endDate}&search=${searchData}`
      //   );
      const res = await httpService.get(
        `motherplant/clones_history?start_date=${startDate}&end_date=${endDate}&search=${searchData}`,
      );
      if (res?.data?.data) {
        setClones(res?.data?.data || []);
        // setRowCount(res?.data?.pagination?.total || 0);
      } else {
        setClones([]);
        setRowCount(0);
      }
    } catch (e) {
      setClones([]);
      setRowCount(0);
    }
    setLoading(false);
  };

  useEffect(() => {
    const dateFilterData = JSON.parse(
      localStorage.getItem("cloneHistoryDateFilter"),
    );
    if (dateFilterData) {
      setStartDate(dateFilterData?.startDate);
      setEndDate(dateFilterData?.endDate);
      setSelectedRadio(dateFilterData?.selectedRadio);
    } else {
      const cloneHistoryDateFilter = {
        startDate: dayjs().startOf("month").format("YYYY-MM-DD"),
        endDate: dayjs().endOf("month").format("YYYY-MM-DD"),
        selectedRadio: "month",
      };
      localStorage.setItem(
        "cloneHistoryDateFilter",
        JSON.stringify(cloneHistoryDateFilter),
      );
    }
    fetchClones();
  }, [searchData]);

  const handleDateTimeModal = () => {
    setOpenDateModal(false);
  };

  const handleOpenDateTimeModal = () => {
    setOpenDateModal(true);
  };

  const columns = [
    // ❌ Removed Select All functionality
    { field: "plant_name", headerName: "Plant Name", flex: 1, minWidth: 150 },
    {
      field: "mother_metrc_id",
      headerName: "Mother Plant METRC ID",
      flex: 1,
      minWidth: 270,
    },
    { field: "no_cuts", headerName: "Number of Cuts", flex: 1, minWidth: 130 },
    { field: "tray_no", headerName: "Tray Number", flex: 1, minWidth: 130 },
    { field: "tray_id", headerName: "Tray ID", flex: 1, minWidth: 170 },
    {
      field: "employee_name",
      headerName: "Employee Name",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "cut_date",
      headerName: "Date of Cut",
      flex: 1,
      minWidth: 130,
      renderCell: (params) => (
        <div style={{ padding: "10px" }}>
          {params.row?.cut_date
            ? dayjs(params.row.cut_date).format("MM-DD-YYYY")
            : "-"}
        </div>
      ),
    },
  ];

  return (
    <>
      {loading && <FullScreenLoader />}
      <div className="clone">
        <div className="page-title">
          <div className="title-wrap">
            <h1>Take Clone History</h1>
          </div>
        </div>

        <div className="table-filter-wrap d-flex justify-content-between pb-0">
          <div className="header_search-wrap">
            <div className="header_search_bar common_content d-flex">
              <div className="input-group input_group">
                <button className="btn search-btn search_btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <circle
                      cx="9.98856"
                      cy="9.98856"
                      r="8.98856"
                      stroke="#495057"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.2402 16.7071L19.7643 20.222"
                      stroke="#495057"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <input
                  type="search"
                  className="form-control form_control"
                  placeholder="Search..."
                  aria-label="Search"
                  onChange={(e) => setSearchData(e.target.value)}
                />
              </div>
            </div>
          </div>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => handleOpenDateTimeModal()}
            className="filters-btn"
            style={{ textTransform: "none" }}
          >
            <TbFilterEdit /> Filters
          </Button>
        </div>

        {/* ❌ Removed Delete button */}

        <div
          style={{
            height: `${clones?.length > 0 ? "" : "200px"}`,
            // height: "465px",
            width: "100%",
            marginTop: 24,
          }}
        >
          <DataGrid
            rows={clones}
            columns={columns}
            loading={loading}
            rowCount={rowCount}
            pageSizeOptions={[15, 50, 100]}
            paginationModel={{ pageSize, page }}
            paginationMode="server"
            onPaginationModelChange={({ page, pageSize }) => {
              setPage(page);
              setPageSize(pageSize);
            }}
            getRowHeight={() => "auto"}
            sx={{
              border: "1px solid #E0E0E0",
              [`& .${gridClasses.cell}`]: { py: 0.5 },
            }}
            autoHeight
            hideFooter
            showCellVerticalBorder
            showColumnVerticalBorder
          />
        </div>
      </div>

      {/* Filter Modal */}
      {openDateModal && (
        <DateTimeModal
          handleDateTimeModal={() => handleDateTimeModal()}
          setStartDate={(e) => setStartDate(e)}
          setEndDate={(e) => setEndDate(e)}
          open={openDateModal}
          fetchSchedule={() => {
            fetchClones();
            const cloneHistoryDateFilter = {
              startDate: startDate,
              endDate: endDate,
              selectedRadio: selectedRadio,
            };
            localStorage.setItem(
              "cloneHistoryDateFilter",
              JSON.stringify(cloneHistoryDateFilter)
            );
          }}
          selectedRadio={selectedRadio}
          setSelectedRadio={(e) => setSelectedRadio(e)}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </>
  );
};

export default CloneHistory;
